import { handleError } from "@/_helpers/utils";
import Axios from 'axios';

export default {
  namespaced: true,
  state() {
    return {
      loaded: false,
      loading: false,
      created: false,
      error: null,
      project_id: null,
      account_id: null
    }
  },
  actions: {
    load(context) {
      context.commit('set_loaded', false);
      context.commit('set_error', null);
      return Axios.get(`/1.0/talentq/vacancy-project/${context.getters.vacancy_id}`)
        .then(response => response.data.data)
        .then(data => {
          if (data.project) {
            context.commit('set_project_id', data ? data.project.id : null);
            context.commit('set_account_id', data ? data.project.account.id : null);
            context.commit('set_created', true);
          }
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          throw err;
        })
    },
    save_project(context, project_id) {
      if (context.getters.loading) return Promise.resolve();
      if (!project_id) return context.dispatch('remove_project');
      const old_project_id = context.getters.project_id;
      context.commit('set_loading', true);
      context.commit('set_error', null);
      context.commit('set_project_id', project_id);
      return Axios[context.state.created ? 'put' : 'post'](`/1.0/talentq/vacancy-project`, {
        project_id,
        vacancy_id: context.getters.vacancy_id,
      })
        .then(() => {
          context.commit('set_loading', false);
          if (!context.state.created) {
            context.commit('set_created', true);
          }
        })
        .catch((err) => {
          err = handleError(err);
          context.commit('set_project_id', old_project_id);
          context.commit('set_loading', false);
          throw err;
        })
    },
    remove_project(context) {
      if (context.getters.loading) return Promise.resolve();
      const old_project_id = context.getters.project_id;
      context.commit('set_loading', true);
      context.commit('set_error', null);
      context.commit('set_project_id', null);
      context.commit('set_created', false);
      return Axios.delete(`/1.0/talentq/vacancy-project/${context.getters.vacancy_id}`)
        .then(() => {
          context.commit('set_loading', false);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_project_id', old_project_id);
          context.commit('set_created', true);
          context.commit('set_loading', false);
          throw err;
        })
    },
    save_account(context, account_id) {
      context.commit('set_account_id', account_id);
      return context.dispatch('remove_project');
    },
  },
  mutations: {
    set_loaded(state, loaded) {
      state.loaded = loaded;
    },
    set_loading(state, loading) {
      state.loading = loading;
    },
    set_created(state, created) {
      state.created = created;
    },
    set_error(state, error) {
      state.error = error;
    },
    set_project_id(state, project_id) {
      state.project_id = project_id;
    },
    set_account_id(state, account_id) {
      state.account_id = account_id;
    },
  },
  getters: {
    loaded: state => state.loaded,
    loading: state => state.loading,
    error: state => state.error,
    project_id: state => state.project_id,
    account_id: state => state.account_id,
    vacancy_id: (state, getters, rootState) => rootState.route.params.id
  }
}